import React, { ReactElement, SyntheticEvent } from 'react';
import { useParams } from 'react-router-dom';

import { Dropdown, Loader } from 'ui/patterns';
import { Button } from 'ui/components';

import {
  useDeleteCustomTable,
  useImportTemplate,
  useExportCustomTable,
} from 'hooks';

import * as Icon from 'assets/icons';

import { confirmAlert } from 'utils/confirm-alert';
import { showSuccessToast, showErrorToast } from 'utils/showToast';

import { ErrorModal } from 'types/modalTypes';
import { TableCustomTableOptionType } from './customTables';

export default function TableOptionsHeader(
  props: TableCustomTableOptionType,
): ReactElement {
  const params = useParams<{
    accountId: string;
  }>();
  const accountId = parseInt(params.accountId);
  const { mutate: deleteTable, isLoading } = useDeleteCustomTable();
  const { mutate: importTemplate, isLoading: isImportTemplateLoading } =
    useImportTemplate();
  const { mutate: exportTemplate, isLoading: isExportTemplateLoading } =
    useExportCustomTable();

  //change
  function handleExport() {
    exportTemplate(
      { accountId, lookupId: props.row.original.Id },
      {
        onError: (error: ErrorModal) => {
          showErrorToast({
            message: error.Errors[0].Message,
          });
        },
      },
    );
  }

  //Dont remove need in future
  const handleImportTemplate = () => {
    importTemplate({ accountId, lookupId: props.row.original.Id });
  };

  const handleDeleteTable = () => {
    confirmAlert({
      message: 'Are you sure you want to delete this table?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            deleteTable(
              { tableId: props.row.original.Id, accountId },
              {
                onSuccess: () => {
                  showSuccessToast({
                    message: 'Table deleted successfully.',
                  });
                },
                onError: (error: ErrorModal) => {
                  if (error.StatusCode === 400) {
                    confirmAlert({
                      message: `${error.Errors[0].Message}Are you sure you want to delete this table?`,
                      buttons: [
                        {
                          label: 'Yes',
                          onClick: () => {
                            deleteTable(
                              {
                                tableId: props.row.original.Id,
                                accountId,
                                removeIfAssociationWithDeletedQuestion: true,
                              },
                              {
                                onSuccess: () => {
                                  showSuccessToast({
                                    message: 'Table deleted successfully.',
                                  });
                                },
                                onError: (error: ErrorModal) => {
                                  showErrorToast({
                                    message: error.Errors[0].Message,
                                  });
                                },
                              },
                            );
                          },
                          className: 'pr-btn-primary',
                        },
                        {
                          label: 'No',
                          onClick: () => {
                            //
                          },
                        },
                      ],
                    });
                  } else {
                    showErrorToast({
                      message: error.Errors[0].Message,
                    });
                  }
                },
              },
            );
          },
          className: 'pr-btn-primary',
        },
        {
          label: 'No',
          onClick: () => {
            //
          },
        },
      ],
    });
  };

  const customTableOptions = [
    {
      value: 'Edit Table',
      icon: <Icon.Edit title="Options" />,
      groupEnd: true,
      action: () =>
        props.onEditPress && props.onEditPress(props.row.original.Id),
    },
    {
      value: 'Delete Table',
      icon: <Icon.Delete title="Options" />,
      groupEnd: true,
      action: handleDeleteTable,
    },
    {
      value: 'Import Table',
      icon: <Icon.Import title="Options" />,
      groupEnd: true,
      action: () =>
        props.onImportPress && props.onImportPress(props.row.original),
    },
    // {
    //   value: 'Import Template',
    //   icon: <Icon.Import title="Options" />,
    //   groupEnd: true,
    //   action: () => handleImportTemplate(),
    // },
    {
      value: 'Export Table',
      icon: <Icon.Export title="Options" />,
      action: () => handleExport(),
    },
  ];

  const customTableDropdown = () => (
    <Button
      style={{ padding: '.5em .6em .6em' }}>
      <Icon.DotsVertical title="Options" />
    </Button>
  );

  return (
    <div onClick={(e: SyntheticEvent<HTMLDivElement>) => e.stopPropagation()}>
      <Dropdown
        trigger={customTableDropdown()}
        menuList={customTableOptions}
        position="left-top"
        className="dd-listitem-options"
      />

      {isLoading && isImportTemplateLoading && isExportTemplateLoading && (
        <Loader />
      )}
    </div>
  );
}
